export const PALETTE = ["#F59E0B", "#16A34A", "#0D9488", "#0284C7", "#4F46E5", "#9333EA", "#DB2777", "#475569"];
export const DEFAULT_COLOR = "#0284C7";
export const CANTIERE_COLOR = "#EA580C";
export const PAGAMENTO_COLOR = "#DC2626";
export const PAGATO_COLOR = "#94A3B8";
export const SCADENZA_COLOR = "#7C3AED";
// Arancio e rosso sono riservati a cantieri e pagamenti: gli appuntamenti non li usano.
const RESERVED = ["#E1352A", "#EA580C", "#DC2626"];
export const LEGEND = [
  { label: "Sopralluoghi / appuntamenti", color: DEFAULT_COLOR },
  { label: "Cantieri", color: CANTIERE_COLOR },
  { label: "Pagamenti (rate, tasse)", color: PAGAMENTO_COLOR },
  { label: "Scadenze preventivi", color: SCADENZA_COLOR },
];
export const REMINDER_COLOR = "#F59E0B";
export const SIMPLE_LEGEND = [
  { label: "Appuntamenti", color: DEFAULT_COLOR },
  { label: "Promemoria", color: REMINDER_COLOR },
  { label: "Pagamenti (rate, tasse)", color: PAGAMENTO_COLOR },
];

export const APPT_FIELDS = ["titolo", "contact_id", "cliente_nome", "data", "data_fine", "luogo", "note", "assigned_to", "assigned_nome", "colore"];

// Colore del collaboratore (bordo dell'evento): scelto dall'admin oppure derivato dal suo id.
export const collabColor = (uid, collabColors) => {
  if (!uid) return DEFAULT_COLOR;
  if (collabColors?.[uid]) return collabColors[uid];
  const h = [...uid].reduce((acc, ch) => (acc * 31 + ch.charCodeAt(0)) >>> 0, 7);
  return PALETTE[h % PALETTE.length];
};

// Sopralluoghi sempre blu, salvo colore scelto a mano sul singolo appuntamento.
export const apptColor = (a) => (a.colore && !RESERVED.includes(String(a.colore).toUpperCase()) ? a.colore : DEFAULT_COLOR);

export const pickAppt = (a) => Object.fromEntries(APPT_FIELDS.map((k) => [k, a[k] ?? ""]));

export const localDay = (iso) => {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
